import type { CurrentRiskRating, IANATimezones } from '@gcv/shared';
import { RiskRatingSource } from '@gcv/shared';

import { ExtendedRiskRatingSource, RISK_RATING_SOURCE_LABELS } from 'ui/apps/fi/shared/types';
import { DateTimeHelpers } from 'util/dateTime.util';
import { isRated } from './is-rated';

/** Ratings nobody set by hand read as 'completed'; the rest just carry the date. */
const ASSESSED_SOURCES = [RiskRatingSource.RiskAssessment, RiskRatingSource.MonitoringReview];

export const formatAccountRatingSummary = (
  currentRating?: CurrentRiskRating,
  timezone?: IANATimezones,
  setByName?: string
): string => {
  if (!currentRating || !isRated(currentRating.rating)) {
    return '';
  }

  const source = currentRating.source as RiskRatingSource | ExtendedRiskRatingSource | undefined;
  const setOn = currentRating.set_on
    ? DateTimeHelpers.formatISOToFriendlyDateString(currentRating.set_on, timezone)
    : '';

  if (!source) {
    return '';
  }

  if (source === ExtendedRiskRatingSource.Seeded) {
    const carriedOver = "Carried over from the account's existing rating";

    return setOn ? `${carriedOver}, recorded ${setOn}.` : `${carriedOver}.`;
  }

  // The override is what set the rating, not the source it replaced.
  const effectiveSource = currentRating.overridden ? RiskRatingSource.ManualOverride : source;
  const sourceLabel = RISK_RATING_SOURCE_LABELS[effectiveSource];
  // 'Set manually' already opens with the verb, so it does not take the prefix.
  const label = sourceLabel.startsWith('Set') ? sourceLabel : `Set by ${sourceLabel}`;
  const dated = ASSESSED_SOURCES.includes(effectiveSource as RiskRatingSource) ? `completed ${setOn}` : setOn;
  const by = setByName ? ` by ${setByName}` : '';

  return setOn ? `${label}, ${dated}${by}.` : `${label}${by}.`;
};
